<template>
  <layout-default-app-bar filterable :filters="filters">
    Portaria - Checklist
  </layout-default-app-bar>
</template>

<script>
import { PORTARIA_CHECKLIST_QUERIES } from '@/constants/QUERY_FILTERS';
import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'PortariaChecklistAppBar',

  components: {
    LayoutDefaultAppBar,
  },

  data() {
    return {
      filters: [PORTARIA_CHECKLIST_QUERIES.movimento, PORTARIA_CHECKLIST_QUERIES.operacao],
    };
  },
};
</script>
